import $ajax from 'axios'
// import {Message} from 'element-ui'
import {hideLoad} from '@/tools/loading.js'

/*
  得到七牛上传服务临时token，当前设置为5分钟内有效。正常使用场景为每次上传资源前实时获取，而不是保存下来一直使用 get /cms/GetQiniuUploadToken
  suffix str 文件后缀
  @Param   suffix        query    string     true        "前缀"
   @Param   hashCode      query    string   false        "图片hash"(这个传空)
*/

function getQiNiuToken (suffix, hashCode, fn) {
  $ajax.get(`v2/cms/GetQiniuUploadToken?suffix=${suffix}&hashCode=${hashCode}`).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      try {
        let data = JSON.parse(res.data.data)
        fn && fn(data)
      } catch (e) {
      }
    }
  }).catch(err => {
    hideLoad()
  })
}


/**
 * 删除七牛云图片 post
 * @Param   imgs        query    string     true        "图片链接:url,url,url"
 */
function deleteQiNiuImg (key, fn) {
  let formData = new FormData()
  formData.append('imgs', key)
  $ajax.post(`v2/cms/deleteQiNiuImg`,formData).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    }
  }).catch(err => {
    hideLoad()
  })
}


export {
  getQiNiuToken,
  deleteQiNiuImg
}



// WEBPACK FOOTER //
// ./src/apis/qiniu.js